import React from "react";
import { Trans } from "@lingui/macro";
import headerBackground from "./assets/images/2020-promo.jpg";
import "./MTSheader.css";

export default function MTSHeader() {
  return (
    <div className="mts">
      <header className="header header--new header--mts js-hero with-avantgarde with-mts-h">
        <div className="header__img-wrapper header__img-wrapper--clean">
          <div
            className="b-lazy-bg header__img"
            style={{ backgroundImage: `url(${headerBackground})` }}
          ></div>
          <div className="header__mts"></div>
        </div>
        <div className="header__wrapper header__wrapper--mts">
          <div className="wrapper-xs">
            <div className="header__text">
              <h1 className="H1 mts-h1 with-experimental with-uppercase">
                <Trans>Urban legends</Trans>
                <div className="mts-logo"></div>
              </h1>
              <div className="mts-lead">
                <b>
                  <Trans>Free self-guided tours in cities of Russia created by locals</Trans>
                </b>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}
